export const institutionLogoMap = {
  Chase:
    'https://heard-images.s3.us-west-1.amazonaws.com/assets/chase-logo.png',
  'Wells Fargo':
    'https://heard-images.s3.us-west-1.amazonaws.com/assets/wellsfargo-logo.png',
  'Citibank Online':
    'https://heard-images.s3.us-west-1.amazonaws.com/assets/citibank-logo.png',
}
